// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
body {
    font-family: 'Inter', sans-serif;
    /*font-weight: 100;*/
    color: #333333;
    margin: 0; 
    padding: 0;
}

html {
  scroll-behavior: smooth;
}

img { max-width: 100%; }

main { 
    margin: 0 auto;
    background-color: #F6F6F6;
}



.header {
    height: 56px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 1000;
    transition: background-color 0.5s ease-in-out, box-shadow 0.5s ease-in-out;
    background-color: transparent; /* Changed from white */
    box-shadow: none; /* Changed from 0 2px 4px rgba(0, 0, 0, 0.1) */
}

.header-scrolled {
    background-color: rgba(255, 255, 255, 0.95); /* Add this new class for scrolled state */
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.mega-menu {
    position: relative;
    width: 100%;
}

.menu-bar {
    display: flex;
    justify-content: center;
    color: #333;
    /*    padding: 10px;*/
}

.menu-item {
    color: black;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 1.0s;
}

.menu-item:hover {
    background-color: #F2F2F2;
}

.menu-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    /* padding: 20px; */
    padding-top: 76px;
    padding-bottom: 20px;

    position: fixed;
    color: black;
    top: 0;
    left: 0;
    
    width: 100%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out, 0.5s ease-in-out;
    transform: translateY(-25%);
    transform-origin: top;
    opacity: 0;
    visibility: hidden;
    z-index: 900;
}

.menu-content.active {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
}`, "",{"version":3,"sources":["webpack://./frontends/ecstore-frontend/html/style.css"],"names":[],"mappings":";AACA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,cAAc;IACd,SAAS;IACT,UAAU;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA,MAAM,eAAe,EAAE;;AAEvB;IACI,cAAc;IACd,yBAAyB;AAC7B;;;;AAIA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,MAAM;IACN,aAAa;IACb,0EAA0E;IAC1E,6BAA6B,EAAE,uBAAuB;IACtD,gBAAgB,EAAE,8CAA8C;AACpE;;AAEA;IACI,2CAA2C,EAAE,0CAA0C;IACvF,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;;IAEpB,eAAe;IACf,YAAY;IACZ,MAAM;IACN,OAAO;;IAEP,WAAW;IACX,wCAAwC;IACxC,uBAAuB;IACvB,wCAAwC;IACxC,mFAAmF;IACnF,2BAA2B;IAC3B,qBAAqB;IACrB,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,wBAAwB;IACxB,UAAU;IACV,mBAAmB;AACvB","sourcesContent":["\nbody {\n    font-family: 'Inter', sans-serif;\n    /*font-weight: 100;*/\n    color: #333333;\n    margin: 0; \n    padding: 0;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nimg { max-width: 100%; }\n\nmain { \n    margin: 0 auto;\n    background-color: #F6F6F6;\n}\n\n\n\n.header {\n    height: 56px;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    width: 100%;\n    top: 0;\n    z-index: 1000;\n    transition: background-color 0.5s ease-in-out, box-shadow 0.5s ease-in-out;\n    background-color: transparent; /* Changed from white */\n    box-shadow: none; /* Changed from 0 2px 4px rgba(0, 0, 0, 0.1) */\n}\n\n.header-scrolled {\n    background-color: rgba(255, 255, 255, 0.95); /* Add this new class for scrolled state */\n    backdrop-filter: blur(10px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.mega-menu {\n    position: relative;\n    width: 100%;\n}\n\n.menu-bar {\n    display: flex;\n    justify-content: center;\n    color: #333;\n    /*    padding: 10px;*/\n}\n\n.menu-item {\n    color: black;\n    padding: 10px 20px;\n    cursor: pointer;\n    transition: background-color 1.0s;\n}\n\n.menu-item:hover {\n    background-color: #F2F2F2;\n}\n\n.menu-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    /* padding: 20px; */\n    padding-top: 76px;\n    padding-bottom: 20px;\n\n    position: fixed;\n    color: black;\n    top: 0;\n    left: 0;\n    \n    width: 100%;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    background-color: white;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out, 0.5s ease-in-out;\n    transform: translateY(-25%);\n    transform-origin: top;\n    opacity: 0;\n    visibility: hidden;\n    z-index: 900;\n}\n\n.menu-content.active {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    transform: translateY(0);\n    opacity: 1;\n    visibility: visible;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
